import styled from 'styled-components'

const ControlWrapper = styled.div`
  position: absolute;
  top: -34px;
  right: 0;
  display: flex;
  align-items: center;
`

export default ControlWrapper
